import {Model} from 'MWC';

const realRate = 'real_rate',
    defaultShopCreditTerm = 6,
    defaultCreditSum = 10000;

export default class extends Model {
    static fields;

    constructor(data) {
        super();
        this.creditSum = defaultCreditSum;
        this.requiredPayment = 0;
        this.shopCreditTerm = defaultShopCreditTerm;
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            ...data
        };
    }

    changeField(name, value) {
        this[name] = value;
        this.calculateIndicators();
    }

    getCreditSum() {
        return +this.creditSum;
    }

    setCreditSum(value) {
        this.creditSum = value;
    }

    getMinSumEdge() {
        return +this.fields.min;
    }

    getMaxSumEdge() {
        return +this.fields.max;
    }

    getSumStep() {
        return +this.fields.step;
    }

    getMinTermEdge() {
        return this.fields.terms[0];
    }

    getMaxTermEdge() {
        return this.fields.terms[this.fields.terms.length - 1];
    }

    setCurrentCreditTerm() {
        this.shopCreditTerm = defaultShopCreditTerm;
    }

    getCreditTerm() {
        return +this.shopCreditTerm;
    }

    getRealRate() {
        return this.fields[realRate][this.getCreditTerm() - 2];
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    setRequiredPayment(value) {
        this.requiredPayment = value;
    }

    getComission() {
        return this.comission;
    }

    setComission(value) {
        this.comission = value;
    }

    getIncome() {
        return this.income;
    }

    setIncome(value) {
        this.income = value;
    }

    resetIndicators() {
        this.setCreditSum(defaultCreditSum);
        this.setCurrentCreditTerm();
    }

    _roundToTwo(value) {
        return Math.round(value * 100) / 100;
    }

    calculateIndicators() {
        const creditSum = this.getCreditSum();
        const realRatePercent = this.getRealRate();
        const realRate = realRatePercent / 100;

        const requiredPayment = this._roundToTwo(creditSum / this.getCreditTerm());
        this.setRequiredPayment(requiredPayment);

        const comission = this._roundToTwo(creditSum * realRate);
        this.setComission(comission);

        const income = this._roundToTwo(creditSum - comission);
        this.setIncome(income);
    }
}
